import { useFormContext } from 'react-hook-form';
import { FormControlLabel } from 'shared/mui/FormControlLabel/FormControlLabel';
import { Switch } from 'shared/mui/Switch';

import { CommissionsCreateFormValues } from './CommissionsCreateForm';
import { useIsAllowedLadder } from './hooks/useIsAllowedLadder';
import { useLadderToggle } from './hooks/useLadderToggle';
import { CommissionsFormConditionsHeader } from '../components/CommissionsFormConditionsHeader';
import { CommissionsZeroedInput } from '../components/CommissionsZeroedInput';

export const CommissionsCreateConditionsHeader = () => {
  const { watch } = useFormContext<CommissionsCreateFormValues>();
  const transactionTypes = watch('transactionTypes');
  const isLadder = watch('isLadder');
  const { onSwitcherChange } = useLadderToggle();
  const { canUseLadder, isAllowedLadder } = useIsAllowedLadder(transactionTypes);

  return (
    <CommissionsFormConditionsHeader title="Условия комиссии">
      {canUseLadder && (
        <FormControlLabel
          checked={isLadder}
          control={<Switch size="small" />}
          disabled={!isAllowedLadder}
          label="Лесенка"
          onChange={onSwitcherChange}
        />
      )}
      <CommissionsZeroedInput
        disabled={isLadder}
        disabledReason="Нулевая комиссия недоступна для комиссии с Лесенкой по обороту."
      />
    </CommissionsFormConditionsHeader>
  );
};
